<template>
  <div class="code-release-flow-detail">
    <SelectJenkinsJobs ref="SelectJenkinsJobs" v-on:selectComplete="selectJenkinsJobsComplete" :multiple="true"></SelectJenkinsJobs>
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'codeReleaseFlow', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow>
      <TestReport ref="TestReport" v-on:submitComplete="getData"></TestReport>
      <Modal v-model="refuseModal" title="驳回">
        <div>
          <Input v-model="refuseContent" style="width: 100%" type="textarea" :rows="4" placeholder="驳回原因（选填）" />
        </div>
        <div slot="footer">
          <Button type="error" :loading="refuseSubmitting" @click="refuse">驳回</Button>
          <Button @click="refuseModal = false">取消</Button>
        </div>
      </Modal>
      <!-- <Modal v-model="updateModuleModal" title="修改发布模块" :rules="updateModuleRules">
        <Form ref="updateModuleForm" :model="updateModuleForm" :rules="updateModuleRules">
          <FormItem label="发布模块" prop="module">
            <Select v-model="updateModuleForm.module" filterable clearable multiple>
              <Option v-for="item in moduleList" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
      </Form>
      <div slot="footer">
          <Button type="primary" :loading="updateModuleSubmitting" @click="updateModuleSubmit">提交</Button>
          <Button @click="updateModuleModal = false">取消</Button>
      </div>
      </Modal> -->
      <!-- <Modal v-model="editCodeAddressModal" title="编辑文档代码存放地址" @on-cancel="cancelEditCodeAddressModal">
        <Form :model="editCodeAddressForm" :label-width="120" ref="editCodeAddressForm" :rules="validCodeAddress">
          <FormItem label="文档代码存放地址" prop="doc_code_address">
            <Input v-model="editCodeAddressForm.doc_code_address" placeholder="请填写该版本的SVN文档和代码存放地址 ！" />
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="editCodeAddressOK">提交</Button>
        </div>
      </Modal> -->
      <Modal
        v-model="appointModal"
        title="指派整改用户"
        @on-cancel="cancelModal">
        <Form :model="appointForm" :label-width="70" ref="appointForm">
          <FormItem label="指派用户" prop="appoint_user">
            <Select v-model="appointForm.appoint_user" placeholder="请选择指派目标用户" clearable filterable>
              <Option v-for="item in all_user_list" :key="item.key" :value="item.key" :label="item.label"></Option>
            </Select>
          </FormItem>
          <FormItem label="整改意见" prop="correct_remark">
            <Input type="textarea" v-model="appointForm.correct_remark" placeholder="最大200个字符" :maxlength="200" />
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="appointOk">提交</Button>
        </div>
      </Modal>
      <Modal
        v-model="verifyModal"
        title="请填写此次发布版本对应的产品经理"
        @on-cancel="cancelVerifyModal">
        <Form :model="verifyForm" :label-width="70" ref="verifyForm">
          <FormItem label="产品经理" prop="pm">
            <Select v-model="verifyForm.pm" placeholder="请选择此次发布版本对应的产品经理" clearable filterable>
              <Option v-for="item in all_user_list" :key="item.key" :value="item.key" :label="item.label"></Option>
            </Select>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="verifyOk">提交</Button>
        </div>
      </Modal>
      <Modal
        v-model="notifyModal"
        width="1000"
        title="发布上线通知"
        @on-cancel="cancelNotifyModal">
        <Form :model="notifyForm" :label-width="120" ref="notifyForm" :rules="ruleValidateNotify">
          <FormItem label="接收通知群组" prop="notify_user">
            <Select v-model="notifyForm.notify_user" placeholder="请选择接收通知群组" clearable filterable multiple>
              <Option v-for="item in all_email_list" :key="item.key" :value="item.key" :label="item.label"></Option>
            </Select>
          </FormItem>
          <FormItem label="接收通知个人" prop="notify_user_tmp">
              <!-- <Input v-model="inventoryChangeForm.counting_people" /> -->
              <Treeselect  v-model="notifyForm.notify_user_tmp" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object"
                :multiple="true" :options="options"  :load-options="loadOptions" :searchable="false" :disableBranchNodes="true" placeholder="选择接收通知人">
              <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar">{{ node.label }}
              </label>
              </Treeselect>
          </FormItem>
          <!-- <FormItem label="使用手册和培训资料地址" prop="guide_address">
            <Input v-model="notifyForm.guide_address" placeholder="最大200个字符" :maxlength="200" />
          </FormItem> -->
          <FormItem label="产品名称+版本号" prop="notify_version">
            <Input v-model="notifyForm.notify_version" placeholder="最大200个字符" :maxlength="200" />
          </FormItem>
          <FormItem label="发布日期" prop="notify_time">
            <Input v-model="notifyForm.notify_time" :maxlength="200" />
          </FormItem>
          <FormItem label="产品经理" prop="notify_cpjl">
            <Input v-model="notifyForm.notify_cpjl" :maxlength="200" />
          </FormItem>
          <!-- <FormItem label="项目经理" prop="notify_xmjl">
            <Input v-model="notifyForm.notify_xmjl" :maxlength="200" />
          </FormItem>
          <FormItem label="测试经理" prop="notify_csjl">
            <Input v-model="notifyForm.notify_csjl" :maxlength="200" />
          </FormItem>
          <FormItem label="发布经理" prop="notify_fbjl">
            <Input v-model="notifyForm.notify_fbjl" :maxlength="200" />
          </FormItem> -->
          <FormItem label="使用用户" prop="notify_syyh">
            <Input v-model="notifyForm.notify_syyh" :maxlength="300" />
          </FormItem>
          <FormItem label="版本更新内容" prop="notify_content" class="code-release-notify-content">
            <vue-editor v-model="notifyForm.notify_content" ref="myQuillEditor" :editorOptions="editorOption"></vue-editor>
            <!-- <Input type="textarea" :rows="5" v-model="notifyForm.notify_content" placeholder="请填写版本更新内容说明" :maxlength="2000" /> -->
          </FormItem>
          <FormItem label="邮件正文" prop="notify_body">
            <vue-editor v-model="notifyForm.notify_body" ref="myQuillEditorBody" :editorOptions="editorOptionBody" class="code-release-notify-email"></vue-editor>
          </FormItem>
        </Form>
        <div slot="footer">
            <Button type="success" @click="notifyOk">发布通知</Button>
        </div>
      </Modal>
      <div class="content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px" :gutter="16">
              <Col :xs="24" :sm="24" :md="24" :lg="19">
                <Row class="title">
                  <h4 :style="{float: 'left'}">代码发布申请工作流详情</h4>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt><dd v-if="info.applicant">{{ info.applicant.name ?
                    info.applicant.name : info.applicant.username }}</dd>
                  </dl>
                  <dl>
                    <dt>标题</dt><dd>{{ info.title }}</dd>
                  </dl>
                  <!-- <dl>
                    <dt>发布模块</dt>
                    <dd>
                      <Tag v-for="item in info.module" :key="item.id">{{ item.name }}</Tag>
                      <Button type="warning" size="small" v-if="info.can_update_module" @click="openUpdateModuleModal" style="margin-left: 10px" ghost>修改</Button>
                    </dd>
                  </dl> -->
                  <dl>
                    <dt>版本号</dt><dd>{{ info.version }}</dd>
                  </dl>
                  <dl>
                    <dt>发布内容</dt>
                    <dd class="code-release-detail-describe"><span v-html="info.describe"></span></dd>
                  </dl>
                  <!-- <dl>
                    <dt>测试报告</dt>
                    <dd><a v-on:click="$refs.TestReport.openModal($route.params.id)">点击查看</a></dd>
                  </dl> -->
                  <!-- <dl>
                    <dt>测试报告附件</dt>
                    <dd>
                      <a v-if="info.enclosure" download :href="CodeReleaseFlowEnclosureBaseUrl + info.enclosure" target="_blank">{{ info.enclosure }} (点击下载)</a>
                    </dd>
                  </dl> -->
                  <dl>
                    <dt>软件资产地址</dt>
                    <dd>{{ info.soft_asset_address }}</dd>
                  </dl>
                  <dl>
                    <dt>项目文档SVN地址</dt>
                    <dd>{{ info.test_report_address }}</dd>
                  </dl>
                  <!-- <dl>
                    <dt>文档和代码存放地址</dt>
                    <dd>{{ info.doc_code_address }}</dd>
                    <Button type="warning" size="small" @click="openCodeAddressModal" v-show="isCodeAddressEditShow">编辑</Button></dd>
                  </dl> -->
                  <dl>
                    <dt>优先级</dt>
                    <dd>{{ info.priority_verbose }}</dd>
                  </dl>
                  <dl>
                    <dt>发布类型</dt>
                    <dd>
                      <Tag v-for="item in info.type" :key="item">{{ item === 0 ? 'Bug修复' : item === 1 ? '功能维护' : item === 2 ? '新功能增加' : item === 3 ? '代码优化' : '' }}</Tag>
                    </dd>
                  </dl>
                  <dl v-if="info.created_at">
                    <dt>申请时间</dt><dd>{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="info.released_at">
                    <dt>发布时间</dt><dd>{{ moment(info.released_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="info.custom_build_time">
                    <dt>用户选择的构建时间</dt><dd>{{ moment(info.custom_build_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="info.developer.length > 0">
                    <dt>通知开发人员</dt><dd>{{ info.developer.map(item => item.name).join(',') }}</dd>
                  </dl>
                  <dl v-if="info.can_apply_build_product">
                    <dt>Jenkins Job选择</dt>
                    <dd>
                    <Button type="default" size="small" @click="openSelectJenkins('codeFlowForm')"  style="margin-right: 5px;position: relative;z-index: 2;">
                      <span>选择</span>
                    </Button>
                    <Tag color="primary" v-for="(item, index) in codeFlowForm.jenkins_job" :key="'job_' + index">{{ item.name }}</Tag>
                    </dd>
                  </dl>
                  <!-- <dl>
                    <dt>状态</dt>
                    <dd>
                      <span style="margin-right: 20px">
                        <Tag v-if="info.status_verbose === '已发布'" color="green">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '驳回'" color="red">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '回滚失败'" color="red">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '构建失败'" color="red">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '出错'" color="red">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '测试环境构建失败'" color="red">{{ info.status_verbose }}</Tag>
                        <Tag v-else-if="info.status_verbose === '已回滚'" color="yellow">{{ info.status_verbose }}</Tag>
                        <Tag v-else color="blue">{{ info.status_verbose }}</Tag>
                      </span>
                    </dd>
                  </dl> -->
                  <dl v-if="info.status !== 0">
                    <dt>进度</dt>
                    <dd style="margin: 10px 0">
                      <Steps v-if="info.type.length === 1 && info.type.indexOf(0) > -1" :current="info.status === 4 ? 1 : info.status === 5 ? 2 : info.status === 3 ? 3 : 4" size="small">
                        <Step title="申请"></Step>
                        <Step title="测试审批"></Step>
                        <Step title="项目经理审批"></Step>
                        <Step title="运维发布"></Step>
                        <Step title="流程结束"></Step>
                      </Steps>
                      <Steps v-else-if="info.tenant_id === 169" :current="info.status === 4 ? 1 : info.status === 5 ? 2 : [3,31].indexOf(info.status) > -1 ? 3 : [9,11].indexOf(info.status) > -1 ? 4 : info.status === 30 ? 5 : [35,34].indexOf(info.status) > -1  ? 6 : info.status === 33 ? 7 : 8" size="small">
                        <Step title="申请"></Step>
                        <Step title="测试审批"></Step>
                        <Step title="项目经理审批"></Step>
                        <Step title="运维发布"></Step>
                        <Step title="测试线上验证"></Step>
                        <Step title="发布上线通知"></Step>
                        <Step title="流程结束"></Step>
                      </Steps>
                      <Steps v-else :current="info.status === 4 ? 1 : info.status === 5 ? 2 : [3,31].indexOf(info.status) > -1 ? 3 : [9,11].indexOf(info.status) > -1 ? 4 : [30,34].indexOf(info.status) > -1  ? 6 : info.status === 33 ? 7 : 8" size="small">
                        <Step title="申请"></Step>
                        <Step title="测试审批"></Step>
                        <Step title="项目经理审批"></Step>
                        <Step title="运维发布"></Step>
                        <Step title="测试线上验证"></Step>
                        <Step title="发布上线通知"></Step>
                        <Step title="维护组验收"></Step>
                        <Step title="整改中"></Step>
                        <Step title="流程结束"></Step>
                      </Steps>
                    </dd>
                  </dl>
                  <dl style="margin-top: 15px">
                    <dt>操作</dt>
                    <dd>
                      <!-- <Approves v-if="[4,5].indexOf(info.status)> -1" :approves="info.approves" approveType="code_release" :reFresh="this.handleReFresh" :status="info.status"/> -->
                      <Approves :approves="info.approves" approveType="code_release" :reFresh="this.handleReFresh" :status="info.status"/>
                      <!-- <Button type="primary" size="small" @click="applyBuildProduct" v-if="info.can_apply_build_product" style="margin-right: 8px">申请发布生产环境</Button> -->
                      <!-- <Button type="error" size="small" v-if="info.can_refuse" @click="refuseModal = true">我要驳回</Button> -->
                      <Button type="primary" size="small" @click="applyBuildProduct" v-if="info.can_apply_build_product" style="margin-right: 8px">立即构建</Button>
                      <Button type="primary" size="small" @click="applyBuildProductConfirm" v-if="info.can_apply_build_product" style="margin-right: 8px">确认发布成功</Button>
                      <!-- <Button type="primary" size="small" @click="applyBuildProduct" v-if="info.can_apply_build_product" style="margin-right: 8px">加入定时任务</Button> -->
                      <Button type="error" size="small" @click="rollbackProduct" v-if="info.can_rollback_product" style="margin-right: 8px">我要回滚</Button>
                      <Button type="primary" size="small" @click="verifyOnlineSuccess" v-if="info.can_verify"  style="margin-right: 8px">验证通过</Button>
                      <Button type="error" size="small" @click="verifyOnlineError" v-if="info.can_verify"  style="margin-right: 8px">验证未通过</Button>
                      <Button type="primary" size="small" @click="acceptSuccess"   v-if="info.can_accept"  style="margin-right: 8px">验收通过</Button>
                      <Button type="error" size="small" @click="acceptError"  v-if="info.can_accept"  style="margin-right: 8px">验收未通过</Button>
                      <Button type="success" size="small" @click="correct_ok"  v-if="info.can_correct_ok"  style="margin-right: 8px">整改完毕</Button>
                      <Button type="success" size="small" @click="notify"  v-if="info.can_notify"  style="margin-right: 8px">发布上线通知</Button>
                    </dd>
                  </dl>
                </div>
                <!-- <Row className="margin-top-10">
                  <Row class="title">
                    <h4 :style="{float: 'left'}">代码发布申请工作流详情</h4>
                  </Row></Row> -->
                  <Row className="margin-top-10" v-if="(info.status === 3 || info.status > 5) && isMaintain">
                    <Row class="title">
                      <h4 :style="{float: 'left'}">构建任务</h4>
                      <!-- <a v-on:click="getData()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a> -->
                    </Row>
                    <BuildTasks ref="BuildTasks" :job-flow-id="$route.params.id"></BuildTasks>
                  </Row>
                </Col>
                <Col :md="{ span: 5, offset: 0 }" v-if="browserType === 'pc'">
                  <div class="title" >
                    <h4>日志信息</h4>
                  </div>
                  <FlowLogs :logs = "info.logs" />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailCodeReleaseFlow,
  refuseCodeReleaseFlowBuildTask, CodeReleaseFlowEnclosureBaseUrl, updateCodeReleaseFlowStatus, applyCodeReleaseFlowBuildProduct, applyCodeReleaseFlowRollback,
  updateModuleCodeReleaseFlow, editCodeAddressApi, appointApi, verifyOkApi, notifyOkApi, GetALLEmails, applyCodeReleaseFlowBuildProductConfirm } from '@/api/workflow/code_release_flow'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'
import TestReport from './components/test-report'
import BuildTasks from './components/build'
import { getModuleAllList } from '@/api/workflow/project'
import { GetALLUsers } from '@/api/user'
import SelectJenkinsJobs from '@/view/tools/jenkins/components/select-jenkins-jobs'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import { Treeselect, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as cmdbRequestApi from '@/api/cmdb'

export default {
  components: {
    FlowLogs,
    Approves,
    TestReport,
    VueEditor,
    Treeselect,
    SelectJenkinsJobs,
    BuildTasks
  },
  data () {
    return {
      isMaintain: this.$store.state.user.groups.filter(item => item.name === '运维组').length > 0,
      codeFlowForm: {
        id: '',
        jenkins_job: []
      },
      options: [],
      editorOption: {
        placeholder: '输入版本更新内容说明'
      },
      editorOptionBody: {
        placeholder: '输入邮件正文内容,例如 Deal ALL: xxx',
        modules: {
          toolbar: [['bold', 'italic']]
        }
      },
      notifyModal: false,
      appointModal: false,
      verifyModal: false,
      appointForm: {
        appoint_user: '',
        correct_remark: ''
      },
      verifyForm: {
        pm: ''
      },
      notifyForm: {
        notify_user: [],
        notify_user_tmp: [],
        guide_address: '',
        notify_version: '',
        notify_time: '',
        notify_cpjl: '',
        notify_xmjl: '',
        notify_csjl: '',
        notify_fbjl: '',
        notify_syyh: '',
        notify_content: '',
        notify_body: ''
      },
      all_user_list: [],
      all_email_list: [],
      isCodeAddressEditShow: false,
      editCodeAddressModal: false,
      // editCodeAddressForm: {
      //   doc_code_address: ''
      // },
      moment: moment,
      info: {},
      infoError: false,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      CodeReleaseFlowEnclosureBaseUrl: CodeReleaseFlowEnclosureBaseUrl,
      infoTimer: null,
      // 驳回
      refuseModal: false,
      refuseSubmitting: false,
      refuseContent: '',
      // 修改发布模块
      updateModuleSubmitting: false,
      updateModuleModal: false,
      updateModuleForm: {
        module: []
      },
      updateStatusForm: {
        status: null
      },
      updateModuleRules: {
        module: { required: true, type: 'array', message: '请至少选择一个模块' }
      },
      // validCodeAddress: {
      //   doc_code_address: { required: true, message: '文档代码存放地址不能为空', trigger: 'blur' }
      // },
      ruleValidateNotify: {
        // notify_user: { required: true, type: 'array', message: '请至少选择一个接收通知的用户', trigger: 'change' },
        notify_version: { required: true, message: '产品名称+版本号不能为空', trigger: 'blur' },
        notify_time: { required: true, message: '发布日期不能为空', trigger: 'blur' },
        notify_cpjl: { required: true, message: '产品经理不能为空', trigger: 'blur' },
        // notify_xmjl: { required: true, message: '项目经理不能为空', trigger: 'blur' },
        // notify_csjl: { required: true, message: '测试经理不能为空', trigger: 'blur' },
        // notify_fbjl: { required: true, message: '发布经理不能为空', trigger: 'blur' },
        notify_syyh: { required: true, message: '使用用户不能为空', trigger: 'blur' },
        notify_content: { required: true, message: '更新内容不能为空', trigger: 'blur' },
        notify_body: { required: true, message: '邮件正文不能为空', trigger: 'blur' }
      },
      moduleList: [],
      browserType: null
    }
  },
  created: function () {
    let agent = navigator.userAgent.toLowerCase()
    this.browserType = agent.indexOf('android') !== -1 ? 'phone' : agent.indexOf('iphone') !== -1 ? 'phone' : agent.indexOf('ipad') !== -1 ? 'phone' : 'pc'
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.infoTimer)
    this.infoTimer = null
  },
  mounted: function () {
    this.getOrg(1)
  },
  methods: {
    // 打开选中Jenkins对话框
    openSelectJenkins (callbackParams) {
      this.$refs.SelectJenkinsJobs.openModal(this[callbackParams].jenkins_job, '', callbackParams)
    },
    // 选择jenkins完成
    selectJenkinsJobsComplete (jenkinsId, job, callbackParams) {
      // this[callbackParams].jenkins_id = jenkinsId
      this[callbackParams].jenkins_job = job
    },
    eventInput (value, instanceId) {
      console.log(value)
    },
    getOrg (id) {
      let params = {
        parentid: id
      }
      cmdbRequestApi.getWxOrgEmail(params).then(res => {
        console.log(res.data.result)
        if (id === 1) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1
        }
        cmdbRequestApi.getWxOrgEmail(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },
    notifyOk () {
      this.$refs['notifyForm'].validate((valid) => {
        if (valid) {
          console.log(this.notifyForm.notify_user_tmp instanceof Array)
          if (this.notifyForm.notify_user_tmp.length > 0 || this.notifyForm.notify_user.length > 0) {
            this.notifyForm.id = this.info.id
            this.notifyForm.notify_user_tmp = this.notifyForm.notify_user_tmp.map(item => item.id)
            notifyOkApi(this.info.id, this.notifyForm).then(res => {
              const result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.cancelNotifyModal()
                this.getData()
                this.notifyModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败',
                  desc: result.msg
                })
              }
            }).catch(_ => {
            })
          } else {
            this.$Notice.error({
              title: '操作失败',
              desc: '请选择接收发布上线通知的用户'
            })
          }
        }
      })
    },
    // 发布上线通知
    notify () {
      this.notifyForm.notify_time = moment(new Date()).format('YYYY/MM/DD')
      this.notifyForm.notify_version = '傲基' + this.info.tenant_name + this.info.version + '版本'
      this.notifyForm.notify_cpjl = this.info.pm.name
      this.notifyForm.notify_content = this.info.describe
      this.notifyForm.notify_body = '<p><span style="color: rgb(0, 0, 0);">Dear&nbsp;all：</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;1、傲基' + this.info.tenant_name + '系统版本已更新至 ' + this.info.version + '，欢迎登录系统试用最新功能：</span><a href="http://www.aukeyit.com/" target="_blank" style="color: rgb(44, 74, 119); background-color: rgb(255, 255, 255);">www.aukeyit.com</a><span style="color: rgb(0, 0, 0);">。</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;2、如在使用系统过程中产生任何问题，可以通过企业微信工作台-信息部客服-帮助手册 快速获取常见问题解决方案；或选择 工单登记&nbsp;反馈问题。</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;3、本次更新的功能点如下：</span></p>'
      this.notifyForm.notify_syyh = this.info.tenant_name + '系统用户'
      this.notifyModal = true
    },
    // 获取所有客服列表
    getAllUsersData () {
      this.all_user_list = []
      GetALLUsers().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有Email列表
    getAllEmailsData () {
      this.all_email_list = []
      GetALLEmails().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_email_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // openCodeAddressModal () {
    //   this.editCodeAddressForm.doc_code_address = this.info.doc_code_address
    //   this.editCodeAddressModal = true
    // },
    // cancelEditCodeAddressModal () {
    //   this.editCodeAddressModal.doc_code_address = ''
    // },
    editCodeAddressOK () {
      this.$refs['editCodeAddressForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.editCodeAddressForm.id = this.info.id
          editCodeAddressApi(this.editCodeAddressForm).then(res => {
            const result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getData()
              this.editCodeAddressModal = false
              this.cancelEditCodeAddressModal()
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          }).catch(_ => {
          })
        }
      })
    },
    // 初始化
    init () {
      this.getData()
      this.getAllUsersData()
      this.getAllEmailsData()
      // this.setInfoTimer()
    },
    // 获取工作流信息
    getData () {
      detailCodeReleaseFlow(this.$route.params.id).then(res => {
        this.info = res.data
        // this.isCodeAddressEditShow = this.info.approves.length > 0 ? this.info.approves[this.info.approves.length - 1].users.indexOf(this.$store.state.user.userName) > -1 : false
        this.infoError = false
      }).catch(res => {
        console.log(res.response)
        this.infoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      this.$Notice.success({
        title: '上传成功'
      })
      this.getData()
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 申请发布生产环境
    applyBuildProduct () {
      // 判断是否选择了jenkins job
      if (this.codeFlowForm.jenkins_job.length === 0) {
        this.$Message['error']({
          background: true,
          content: '请先选择Jenkins job',
          duration: 5
        })
        return
      }
      let data = this.codeFlowForm
      this.$Modal.confirm({
        title: '确认立即发布生产环境吗？',
        content: '确定后系统会根据所选择的jenkins job 立即构建生产环境',
        onOk: () => {
          applyCodeReleaseFlowBuildProduct(this.$route.params.id, data).then(res => {
            this.getData()
            // 构建任务刷新
            this.$refs.BuildTasks.init()
            this.codeFlowForm.jenkins_job = []
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 确认发布生产环境成功
    applyBuildProductConfirm () {
      console.log()
      this.$Modal.confirm({
        title: '确认发布成功了吗',
        content: '确定后系统会给相关人员发送成功通知',
        onOk: () => {
          applyCodeReleaseFlowBuildProductConfirm(this.$route.params.id).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 回滚生产环境
    rollbackProduct () {
      this.$Modal.confirm({
        title: '确认回滚生产环境吗？',
        content: '确定后由运维人员进行回滚生产环境',
        onOk: () => {
          applyCodeReleaseFlowRollback(this.$route.params.id).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证未通过
    verifyOnlineError () {
      this.$Modal.confirm({
        title: '确认线上生产环境验证不通过吗？',
        content: '确定后由运维人员决定是否要进行回滚生产环境',
        onOk: () => {
          this.updateStatusForm = {
            status: 31
          }
          updateCodeReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证通过
    verifyOnlineSuccess () {
      if (this.info.logs.filter(item => item.content.indexOf('回滚生产环境') > -1).length > 0) {
        this.verify_rollback_ok()
      } else {
        // this.verifyModal = true
        this.verifyOk()
      }
    },
    // 测试进行线上验证未通过
    verify_rollback_ok () {
      this.$Modal.confirm({
        title: '确认回滚后的生产环境验证通过吗？',
        content: '确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 50
          }
          updateCodeReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证未通过
    correct_ok () {
      this.$Modal.confirm({
        title: '确认已经整改完毕吗？',
        content: '确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 34
          }
          updateCodeReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 维护组验收未通过
    acceptSuccess () {
      this.$Modal.confirm({
        title: '确认线上生产环境验收通过吗？',
        content: '请详细检查相关资料是否齐全,确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 32
          }
          updateCodeReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    cancelNotifyModal () {
      this.notifyForm = {
        notify_user: '',
        guide_address: ''
      }
    },
    cancelModal () {
      this.appointForm = {
        appoint_user: '',
        correct_remark: ''
      }
    },
    cancelVerifyModal () {
      this.verifyForm = {
        pm: ''
      }
    },
    appointOk () {
      this.$refs['appointForm'].validate((valid) => {
        if (valid) {
          this.appointForm.id = this.info.id
          if (this.appointForm.appoint_user) {
            appointApi(this.info.id, this.appointForm).then(res => {
              const result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.cancelModal()
                this.getData()
                this.appointModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败',
                  desc: result.msg
                })
              }
            }).catch(_ => {
            })
          } else {
            this.$Notice.error({
              title: '操作失败',
              desc: '请填指派用户'
            })
          }
        }
      })
    },
    verifyOk () {
      verifyOkApi(this.info.id, this.verifyForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.cancelVerifyModal()
          this.getData()
          this.verifyModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(_ => {
      })
    },
    // 维护组验收不通过
    acceptError () {
      this.appointModal = true
    },
    // setInfoTimer () {
    //   clearInterval(this.infoTimer)
    //   this.infoTimer = null
    //   if (this.infoTimer == null) {
    //     this.infoTimer = setInterval(() => {
    //       this.getData()
    //     }, 5000)
    //   }
    // },
    // 驳回
    refuse () {
      this.refuseSubmitting = true
      refuseCodeReleaseFlowBuildTask(this.$route.params.id, this.refuseContent).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.refuseSubmitting = false
        this.refuseModal = false
      }).catch(res => {
        this.refuseSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    openUpdateModuleModal () {
      this.updateModuleForm.module = this.info.module.map(item => item.id)
      this.getModuleList()
      this.updateModuleModal = true
    },
    // 获取模块列表
    getModuleList () {
      getModuleAllList({ tenant_id__in: this.info.tenant_id }).then(res => {
        this.moduleList = res.data
      })
    },
    // 修改发布模块
    updateModuleSubmit () {
      this.$refs.updateModuleForm.validate((valid) => {
        if (valid) {
          this.updateModuleSubmitting = true
          updateModuleCodeReleaseFlow(this.$route.params.id, this.updateModuleForm).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.updateModuleModal = false
            this.updateModuleSubmitting = false
            this.getData()
          }).catch(res => {
            this.updateModuleSubmitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .code-release-detail-describe {
    padding: 0;
    overflow-y: auto;
    max-height: 350px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar {
    width: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .code-release-detail-describe::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  .code-release-notify-content {
    .ivu-form-item-content {
      line-height: unset !important;
    }
    .ql-snow.ql-toolbar {
      padding-top: unset !important;
      padding-bottom: unset !important;
    }
    .ql-toolbar.ql-snow {
      padding: unset;
    }
    .ql-formats {
      margin-top: 3px;
      margin-bottom: unset !important;
      button svg {
        width: unset !important;
        height: unset !important;
      }
    }
  }
  .code-release-notify-email {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
